import { render, staticRenderFns } from "./BaseCardCreateUpdate.vue?vue&type=template&id=0180267c&scoped=true&"
import script from "./BaseCardCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BaseCardCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardCreateUpdate.vue?vue&type=style&index=0&id=0180267c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180267c",
  null
  
)

export default component.exports